import QuizStep from "@/icons/ui/quiz-step.svg";
import ReceiveTreatmentStep from "@/icons/ui/receive-treatment-step.svg";
import StartTreatmentStep from "@/icons/ui/start-treatment-step.svg";

import type { GetStartedStep } from "./types";

export const sampleSteps: GetStartedStep[] = [
    {
        id: "quiz",
        title: "Complete our 2-minute health quiz",
        description: <>Help us understand your symptoms to see if Oestra<sup>®</sup> suits you.</>,
        icon: <QuizStep className="w-full h-full" />,
        image: {
            desktop: {
                url: "https://res.cloudinary.com/dirscuuhp/image/upload/v1779710970/new_design/Frame_1171278096_uhqmtb.webp",
                alt: "Health quiz on mobile phone",
            },
            mobile: {
                url: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778660302/new_design/Group_45081_iwgnha.webp",
                alt: "Health quiz on mobile phone",
                width: 309,
                className: "translate-y-[-22px]",
            },
        },
    },
    {
        id: "treatment",
        title: "Receive your prescription treatment",
        description: "Once approved, your meds ship to your door. No visit needed.",
        icon: <ReceiveTreatmentStep className="w-full h-full" />,
        image: {
            desktop: {
                url: "https://res.cloudinary.com/dirscuuhp/image/upload/v1779706608/new_design/Frame_1171278097_xedilt.webp",
                alt: "Shipping and tracking preview",
            },
            mobile: {
                url: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778660898/new_design/Group_45124_e1vqvo.webp",
                alt: "Shipping and tracking preview",
                width: 350,
                className: "translate-x-[-50px] translate-y-[-10px]",
            },
        },
    },
    {
        id: "support",
        title: "Start treatment and get ongoing support",
        description: "Our clinical care team is always here for you whenever you want to check in.",
        icon: <StartTreatmentStep className="w-full h-full" />,
        image: {
            desktop: {
                url: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778505688/new_design/Frame_2087329614_1_n2onuk.webp",
                alt: "Care team supporting your treatment",
            },
            mobile: {
                url: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778492802/new_design/Group_45045_ywpqvv.webp",
                alt: "Care team supporting your treatment",
                width: 461,
                className: "translate-y-[-64px]",
            },
        },
    },
];
